var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtCarouselBusiness = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h60v60H0V0z",
    id: "qfi8jfzlfa"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    xlinkHref: "#qfi8jfzlfa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h60v60H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EFC66F",
    d: "M52.884 17.012 34.147 29.416 14.755 17.143 34.015 5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A37C3D",
    d: "m49.917 16.673-15.94-9.775L17.769 16.94l16.074 10.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFC66F",
    d: "m52.854 17.12.005 26.419-18.79 11.386-.084-25.152z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3A768E",
    d: "m34.03 32.96.063-3.894L52.862 17.11l.051 3.41M34.057 55l-.016-3.46 18.874-11.446.085 3.423"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EABD6B",
    d: "m34.064 29.821-18.97-12.544-.6 24.486 19.57 13.146z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3A768E",
    d: "m34.062 32.905-.005-3.663-18.99-12.013-.06 2.9M34.07 54.976v-3.438L14.567 38.754l-.093 2.992z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3A768E",
    d: "M34.288 32.666h-1v-3.467h1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F3946",
    d: "M29.393 51.78V37.684l-5.311-2.923v13.682"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E6",
    d: "M24.922 36.927v4.733l3.335 1.813v-4.768zM24.869 42.626v4.743l3.309 2.202.019-5.048z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F3946",
    d: "m22.751 33.826-.026 7.114-6.457-4.044V29.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBFCF6",
    d: "m22.373 34.007-.023 6.344-5.758-3.606v-6.567z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#518FA3",
    d: "M34.2 29.14 14.789 17.047 7 27.576l19.57 11.883z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBFCF6",
    d: "m30.77 27.223-7.16 10.48-2.677-1.654 7.258-10.748 2.655 1.783M25.228 23.762l-7.204 10.545-2.692-1.664 7.301-10.814 2.67 1.794M19.792 20.378 12.496 30.95l-2.69-1.621 7.31-10.852 2.755 1.758"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#1F3946"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m39.61 32.497.014 12.356-3.864 2.426V35.114M45.56 28.618l.037 12.467-3.943 2.475-.022-12.274M51.543 24.324l.06 12.575-4.023 2.528-.044-12.38"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m36.256 35.556.027 4.96 2.967-2.019V33.71zM36.332 41.11l-.035 5.09 2.953-1.933.005-5.161zM42.14 31.847l.027 4.959 2.967-2.018V30zM42.216 37.4l-.035 5.09 2.953-1.933.005-5.16zM48.113 27.49l.027 4.96 2.966-2.018v-4.787zM48.189 33.044l-.035 5.09 2.953-1.932.005-5.162z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#626B7C",
    d: "m39.052 11.136 3.865 2.55v4.883l-3.884-2.468z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#545B67",
    d: "m46.783 11.135-3.866 2.55v4.883L46.8 16.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#878A93",
    d: "m39.052 11.136 3.854-2.228 3.877 2.227-3.866 2.55z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtCarouselBusiness);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/art-carousel-business.184a7ad066b7d7af73ca66b8fe1e2f6b.svg";